module.exports = __webpack_public_path__ + "static/media/temp_10.9e69b837.jpg";